import { create } from 'zustand';

export interface PodNumsState {
  podNums: number;
}

export interface PodNumsAction {
  updatePodNums: (num: number) => void;
  reset: () => void;
}

const initPodNums: PodNumsState = {
  podNums: 1,
};

export const usePodNumsStore = create<PodNumsState & PodNumsAction>()((set) => ({
  ...initPodNums,
  updatePodNums: (num) => set({ podNums: num }),
  reset: () => set(initPodNums),
}));
